import StubPage from '../stub/page';

export default function ContentPage() {
  return (
    <StubPage
      title="תוכן"
      subtitle="ניהול דפים וטקסטים"
      icon="ri-file-text-line"
      description="כאן תוכל לנהל את תוכן הדפים, הטקסטים והמידע המוצג באתר."
    />
  );
}
